import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MentionModule } from 'angular-mentions';

@Component({
  selector: 'app-text-area',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MentionModule],
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.css'],
})
export class TextAreaComponent {
  @Input() formName: string = '';
  @Input() formControlValue: string = '';
  @Input() formGroup!: FormGroup;
  @Input() label: string = '';
  @Input() showLabel: boolean = true;
  @Input() showError: boolean = true;
  @Input() isRequired: boolean = false;
  @Input() placeholder: string = '';
  @Input() type: string = '';
  @Input() rows: number = 5;
  @Input() maxlength: string | number = '';
  @Input() errorMessages: { [key: string]: string } = {};
  @Input() backgroundColor: string = '#ffffff';
  @Input() isReadonly: boolean = false;
  @Input() enableMentions: boolean = false;
  @Input() mentionItems: Array<{ id?: any; name: string }> = [];
  constructor() {}

  hasError(): boolean {
    const control = this.formGroup?.get(this.formControlValue);
    return !!(control && control.invalid && control.touched);
  }

  getErrorMessage(): string {
    const control = this.formGroup?.get(this.formControlValue);
    if (control?.errors) {
      const errorKey = Object.keys(control.errors)[0];
      return this.errorMessages[errorKey] || 'Invalid field';
    }
    return '';
  }
  isValid(): boolean {
    const control = this.formGroup?.get(this.formControlValue);
    return !!(control && control.valid && (control.dirty || control.touched));
  }
}
